import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    newTab: { type: Boolean, default: false }
  }

  connect() {
    if (this.newTabValue) {
      const newTab = window.open(this.urlValue, "_blank")

      if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
        // Popup blocked, fallback to same tab redirect
        window.location.href = this.urlValue
      }
    } else {
      window.location.href = this.urlValue
    }
  }
}
